import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import {
  defaultToastSuccess,
  defaultToastError,
  toUTCFormat,
  isNull,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import { urlCreate, urlProcess } from "..";

const SHOW_BUKA_TRANSAKSI = {
  label: "BUKA TRANSAKSI",
  color: "green",
  state: false,
};

export const SHOW_PROCESS = {
  label: "PROCESSS",
  color: "warning",
  state: false,
};

const validation = async (formData) => {
  if (formData.date === "") {
    defaultToastError("Tanggal tidak boleh kosong");
    return false;
  } else if (formData.gudang_id === "") {
    defaultToastError("Gudang tidak boleh kosong");
    return false;
  } else {
    return true;
  }
};

const ModalSimpan = ({
  setShowModal,
  formData,
  setFormData,
  setNewAllData,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI);
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS);

  // useEffect(() => {
  //   return () => {
  //     setFormData({});
  //   };
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickBukaTransaki = async (e) => {
    e.preventDefault();
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT);

    try {
      const valid = await validation(formData);
      if (valid) {
        const api = await instance4.post(urlCreate, {
          date: toUTCFormat(formData.date),
          gudang_id: formData.gudang_id,
          flag: 0,
        });

        const res = await api?.data;

        if (res.status === 200) {
          setShowModal(false);
          await setNewAllData();
          setFormData({
            ...formData,
            id: res.id,
          });
          defaultToastSuccess(res?.message);
        } else {
          defaultToastError(res.message);
        }
      }
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickProcess = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledProcess(SHOW_PROCESS);
      } else {
        const api = await instance4.post(urlProcess, {
          id: formData.id,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setFormData({
            ...formData,
            status: true,
          });
          setDisabledProcess(SHOW_PROCESS);
          defaultToastSuccess(res?.message);
          setShowModal(false);
        } else {
          defaultToastError(res.message);
        }
      }
    } catch (error) {
      setDisabledProcess(SHOW_PROCESS);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal width='30%' title={"Simpan"} show={setShowModal}>
      {formData.status ? (
        <> Transaksi sudah diprocess </>
      ) : (
        <Grid container direction='row' alignItems='center'>
          {isNull(formData.id) ? (
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              disabled={disabledBukaTransaksi.state}
              color={disabledBukaTransaksi.color}
              name={disabledBukaTransaksi.label}
              onClick={(e) => handleClickBukaTransaki(e)}
              size='lg'
            />
          ) : (
            <MasterButton
              disabled={formData.id === "" || disabledProcess.state ? true : false}
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={formData.id === "" ? "secondary" : disabledProcess.color}
              onClick={(e) =>  handleClickProcess(e)}
              name={disabledProcess.label}
              size='lg'
            />
          )}
        </Grid>
      )}
    </Modal>
  );
};

export default ModalSimpan;
